<!--
  Angular 15: *ngIf / *ngFor only — the @if block syntax does not exist here.
-->
<div class="dl-page">

  <div class="dl-page__header">
    <div class="dl-page__heading">
      <h1 class="dl-page__title">Dashboard</h1>
      <p class="dl-page__subtitle">New cases across every tenant.</p>
    </div>
    <div class="dl-page__actions">
      <a routerLink="/cases" class="dl-btn">
        View all cases
        <mat-icon>arrow_forward</mat-icon>
      </a>
    </div>
  </div>

  <div *ngIf="error" class="dl-banner dl-banner--error">
    <mat-icon>error</mat-icon>
    <div class="dl-banner__body">{{ error }}</div>
  </div>

  <!-- Each tile filters the case list to its own window. -->
  <div class="dl-stat-grid">
    <button
      *ngFor="let count of counts"
      type="button"
      class="dl-stat dl-stat--action"
      [class.dl-stat--primary]="count.daysBack === 0"
      (click)="viewCasesSince(count.from)">
      <span class="dl-stat__value">{{ count.total === null ? '—' : count.total }}</span>
      <span class="dl-stat__label">{{ count.label }}</span>
    </button>
    <div *ngIf="loading && !counts.length" class="dl-stat">
      <span class="dl-stat__value">…</span>
      <span class="dl-stat__label">Loading</span>
    </div>
  </div>

  <div class="dl-card">
    <div class="dl-card__header">
      <div>
        <h2 class="dl-card__title">Newest cases</h2>
        <p class="dl-card__subtitle">The 10 most recently created, across all tenants.</p>
      </div>
    </div>

    <div *ngIf="loading" class="dl-loading">
      <div class="dl-spinner"></div>
      <p>Loading the newest cases…</p>
    </div>

    <app-empty-state
      *ngIf="!loading && !recentCases.length"
      icon="folder_open"
      title="No cases yet">
      As soon as a tenant creates one it will show up here.
    </app-empty-state>

    <table *ngIf="recentCases.length" class="dl-table dl-table--cards" dlCardTable>
      <thead>
        <tr>
          <th>Case ID</th>
          <th>Patient</th>
          <th>Tenant</th>
          <th>Doctor</th>
          <th>Tech</th>
          <th>Created</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let case of recentCases; trackBy: trackByCaseId"
          class="dl-row--clickable"
          (click)="viewCaseDetails(case)">
          <td class="dl-cell--title">{{ case.id || 'N/A' }}</td>
          <td>{{ case.patient?.name || 'N/A' }}</td>
          <td (click)="$event.stopPropagation()">
            <ng-container *ngIf="getTenantPartners(case).length; else noTenant">
              <a
                *ngFor="let tenant of getTenantPartners(case); trackBy: trackByPartnerId"
                [routerLink]="['/partners', tenant.id]"
                class="tenant-chip">
                {{ tenant.contact?.name || tenant.id }}
              </a>
            </ng-container>
            <ng-template #noTenant><span class="tenant-empty">—</span></ng-template>
          </td>
          <td>{{ case.doctor?.contact?.name || 'N/A' }}</td>
          <td>{{ case.tech?.contact?.name || 'N/A' }}</td>
          <td>{{ case.createdAt ? (case.createdAt | date:'short') : 'N/A' }}</td>
          <td>
            <span class="case-status" [class]="getCaseStatusClass(case.status)">
              {{ getCaseStatusLabel(case.status) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
